"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var contentRouter = {
  path: '/mealOrder',
  component: _layout.default,
  redirect: '/mealOrder/mealShop',
  name: 'mealOrder',
  meta: {
    title: '小程序装修',
    icon: 'clipboard'
  },
  children: [{
    path: 'mealBrand',
    name: 'mealBrand',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mealOrder/mealView/mealBrand'));
      });
    },
    meta: {
      title: '品牌管理',
      icon: ''
    }
  }, {
    path: 'mealShop',
    name: 'mealShop',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mealOrder/mealView/mealShop'));
      });
    },
    meta: {
      title: '门店管理',
      icon: ''
    }
  }, {
    path: 'mealConfig',
    name: 'mealConfig',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/mealOrder/mealView/mealConfig'));
      });
    },
    meta: {
      title: '线下点餐配置',
      icon: ''
    }
  }]
};
var _default = exports.default = contentRouter;